<template>
  <div class="home-v2">
    <div style="display: flex;">
      <Sidebar />
      <div v-if="$store.state.kpiStore.active_page === 'for_isupplier'">
        <iSupplier />
      </div>
      <div v-else-if="$store.state.kpiStore.active_page === 'for_csi'">
        <Csi />
      </div>
      <div v-else-if="$store.state.kpiStore.active_page === 'for_sap'">
        <RegSap />
      </div>
      <div v-else-if="$store.state.kpiStore.active_page === 'for_extend_sap'">
        <ExtSap />
      </div>
      <div v-else-if="$store.state.kpiStore.active_page === 'for_k3l'">
        <K3L />
      </div>
      <div v-else-if="$store.state.kpiStore.active_page === 'for_kplh'">
        <KPLH />
      </div>
      <div v-else-if="$store.state.kpiStore.active_page === 'for_ssi_gems'">
        <SsiGems />
      </div>
      <div v-else-if="$store.state.kpiStore.active_page === 'for_ssi_bce'">
        <SsiBce />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
    Loading: () => import('@/components/V2/GlobalLoading'),
    Sidebar: () => import('@/components/dashboard/sidebar/sidebar-kpi.vue'),
    iSupplier: () =>
      import('@/components/dashboard/main-kpi/register-isupplier/main.vue'),
    RegSap: () =>
      import('@/components/dashboard/main-kpi/register-sap/main.vue'),
    ExtSap: () => import('@/components/dashboard/main-kpi/extend-sap/main.vue'),
    K3L: () => import('@/components/dashboard/main-kpi/k3l/main.vue'),
    KPLH: () => import('@/components/dashboard/main-kpi/kplh/main.vue'),
    Csi: () => import('@/components/dashboard/main-kpi/csi-score/main.vue'),
    SsiGems: () => import('@/components/dashboard/main-kpi/ssi-gems/main.vue'),
    SsiBce: () => import('@/components/dashboard/main-kpi/ssi-bce/main.vue')
  },
  data() {
    return {
      currentContent: 'reg-isupp',
    }
  },
}
</script>
